import { isNil } from "lodash";
import { FC, useEffect, useMemo, useState, useTransition } from "react";

import { useDropdownSourceContext } from "@ryde/redux";
import { IProductionChain, NO_VALUE_DISPLAY } from "@ryde/shared";

import { FramerTooltip } from "../../common";
import { useDecorateWithMark } from "../../utils";
import { IRenderColumnTemplate } from "./_core";
import { ProductionChainCellStyled } from "./production-chain-cell.styled";

export const ProductionChainCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
  e2eData,
}) => {
  const { decorateValue } = useDecorateWithMark();
  const { getDropdownLabel } = useDropdownSourceContext();
  const [produceButtonName, setProduceButtonName] = useState<string>("");
  const [, startTransition] = useTransition();

  const productionChain = value as IProductionChain | undefined;
  const produceButtonId = productionChain?.produceButtonId;

  useEffect(() => {
    const getName = async (): Promise<void> => {
      if (isNil(produceButtonId)) {
        setProduceButtonName("");
        return;
      }

      const label = await getDropdownLabel("produceButton", produceButtonId);
      setProduceButtonName(label);
    };

    startTransition(() => {
      getName();
    });
  }, [produceButtonId, getDropdownLabel]);

  const highlightedName = useMemo(
    () => decorateValue(produceButtonName),
    [produceButtonName, decorateValue],
  );

  if (isNil(produceButtonId)) {
    return (
      <ProductionChainCellStyled
        className="cell_simple"
        data-e2e-custom={e2eData}
        data-e2e-type="production-chain-cell-template"
      >
        <span>{NO_VALUE_DISPLAY}</span>
      </ProductionChainCellStyled>
    );
  }

  return (
    <ProductionChainCellStyled
      className="cell_simple"
      data-e2e-custom={e2eData}
      data-e2e-type="production-chain-cell-template"
    >
      <FramerTooltip content={produceButtonName} rtlStrippedBottomLeftPlacement>
        <span className="production-chain-cell__name">{highlightedName}</span>
      </FramerTooltip>
    </ProductionChainCellStyled>
  );
};
